import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { CustomCursor, SmoothScroll, RouteScroll, PageEntrance } from './components/Motion';
import { Toaster } from './components/ui/sonner';
import HomePage from './pages/HomePage';
import WorkPage from './pages/WorkPage';
import AboutPage from './pages/AboutPage';
import './App.css';

const TOAST_DURATION_MS = 4500;

const PAGE_TITLES = { '/work': 'Selected Work', '/about': 'About' };

const PageMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = `${PAGE_TITLES[pathname] || 'Communication Designer'}, Pranjali Saxena`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.appendChild(meta); }
    meta.content = 'Pranjali Saxena is a communication designer in Bengaluru, India. Branding, visual communication, digital design and storytelling. Open to full-time and freelance opportunities.';
  }, [pathname]);
  return null;
};

const NotFound = () => <main id="main-content" className="not-found page-inset" data-testid="not-found"><span className="eyebrow">404 / A SMALL DETOUR</span><h1>This page wandered off.</h1><p>Perhaps it went out for chai. Let's get you back.</p><Link to="/" className="text-link" data-testid="not-found-home">BACK HOME →</Link></main>;

const AnimatedRoutes = () => {
  const location = useLocation();
  return <PageEntrance key={location.pathname}>
    <Routes location={location}>
      <Route path="/" element={<HomePage />} />
      <Route path="/work" element={<WorkPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </PageEntrance>;
};

function App() {
  return <BrowserRouter><MotionConfig reducedMotion="user"><SmoothScroll><PageMeta /><RouteScroll /><CustomCursor />
    <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to content</a>
    <div className="site-shell" id="top"><Navbar /><AnimatedRoutes /><Footer /></div>
    <Toaster position="bottom-right" theme="light" toastOptions={{ className: 'portfolio-toast', duration: TOAST_DURATION_MS }} />
  </SmoothScroll></MotionConfig></BrowserRouter>;
}

export default App;
